<template>
    <app-content class="h-panel">
        <div class="h-panel-bar">
            <span class="h-panel-title">业务凭证</span>
        </div>
        <div class="tp-wrap">
            <!-- 左侧：业务数据源 -->
            <div class="tp-side">
                <div class="tp-side-head">
                    <span>业务数据源</span>
                    <span class="tp-cfg" @click="openDefinitionManager">配置</span>
                </div>
                <div class="tp-side-body">
                    <div v-for="d in definitions" :key="d.id"
                         class="tp-side-item" :class="{selected: d.id === definitionId}" @click="selectDef(d)">
                        <span class="tp-side-name">{{d.name}}</span>
                        <span class="tp-badge">{{d.dataCount}}</span>
                    </div>
                    <div v-if="!definitions.length" class="text-center dark2-color" style="padding:20px 0">暂无数据模型</div>
                </div>
            </div>

            <!-- 右侧：业务数据 -->
            <div class="tp-main">
                <div class="tp-title">
                    {{current.name || '业务数据'}}
                    <span class="tp-desc">{{current.description || '-'}}</span>
                    <span class="tp-cfg float-right" @click="openTpl">凭证模板设置</span>
                </div>

                <div class="tp-toolbar">
                    <DateRangePicker v-model="query.dateRange" format="YYYY-MM-DD" placeholder="请选择日期" :option="{shortcuts:[]}"/>
                    <Select v-model="query.vouchered" :datas="voucheredOptions" :deletable="false"
                            placeholder="请选择凭证状态检索" style="width:150px"/>
                    <Button size="s" @click="showFilter = !showFilter">检索</Button>
                    <div class="float-right">
                        <Button size="s" @click="loadList">查询</Button>
                        <Button size="s" @click="resetQuery">重置</Button>
                        <Button size="s" color="primary" @click="add">新增</Button>
                        <Button size="s" color="red" :disabled="!checkedIds.length" @click="batchDelete">批量删除</Button>
                        <DropdownMenu button size="s" :datas="importExportMenu" @onclick="onImportExport">导入/导出</DropdownMenu>
                        <Button size="s" color="primary" @click="openGenerate">生成凭证</Button>
                    </div>
                </div>

                <!-- 高级检索 -->
                <div class="tp-filter" v-show="showFilter">
                    <div v-for="f in filterFields" :key="f.fieldName" class="tp-filter-item">
                        <label>{{f.displayName}}</label>
                        <template v-if="f.fieldType === 'DATE'">
                            <DateRangePicker v-model="query.filters[f.fieldName]" format="YYYY-MM-DD"
                                             :placeholder="`请选择${f.displayName}检索`"/>
                        </template>
                        <template v-else-if="f.fieldType === 'NUMBER'">
                            <div class="h-input-group" v-if="query.filters[f.fieldName]">
                                <NumberInput v-model="query.filters[f.fieldName].start" placeholder="最小金额"/>
                                <span class="h-input-addon">至</span>
                                <NumberInput v-model="query.filters[f.fieldName].end" placeholder="最大金额"/>
                            </div>
                        </template>
                        <template v-else>
                            <Input v-model="query.filters[f.fieldName]" :placeholder="`请输入${f.displayName}`"/>
                        </template>
                    </div>
                    <div v-if="!filterFields.length" class="dark2-color">该数据模型没有可检索的数据列</div>
                </div>

                <table class="grid">
                    <thead>
                    <tr>
                        <th style="width:44px"><input type="checkbox" :checked="checkAll" @click="toggleAll"></th>
                        <th v-for="f in dataFields" :key="f.fieldName"
                            :style="f.fieldType === 'NUMBER' ? 'width:120px;text-align:right' : ''">
                            {{f.displayName}}
                        </th>
                        <th style="width:150px">关联凭证</th>
                        <th style="width:110px">操作</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in datas" :key="item.id">
                        <td align="center"><input type="checkbox" v-model="item._checked" :disabled="item.voucherId"></td>
                        <td v-for="f in dataFields" :key="f.fieldName" :align="f.fieldType === 'NUMBER' ? 'right' : ''">
                            {{formatValue(item.dataValue[f.fieldName], f)}}
                        </td>
                        <td>
                            <span v-if="item.voucherCode" class="blue-color">{{item.voucherCode}}</span>
                            <span v-else class="dark2-color">未生成</span>
                        </td>
                        <td class="actions">
                            <span @click="edit(item)">编辑</span>
                            <span v-if="!item.voucherId" @click="remove(item)">删除</span>
                        </td>
                    </tr>
                    <tr v-if="!datas.length">
                        <td :colspan="dataFields.length + 3" class="text-center" style="padding:20px">暂无数据</td>
                    </tr>
                    </tbody>
                    <tfoot v-if="datas.length">
                    <tr>
                        <td></td>
                        <td v-for="f in dataFields" :key="f.fieldName" :align="f.fieldType === 'NUMBER' ? 'right' : ''">
                            <template v-if="isFirstNumber(f)">合计</template>
                            <template v-else-if="f.fieldType === 'NUMBER'">{{sumOf(f)}}</template>
                        </td>
                        <td></td>
                        <td></td>
                    </tr>
                    </tfoot>
                </table>
                <Pagination v-model="pagination" @change="currentChange" layout="pager" small align="center" v-if="datas.length"/>
            </div>
        </div>

        <!-- 数据模型管理 -->
        <Modal v-model="defManagerShow" type="drawer-right" hasCloseIcon :width="900">
            <div class="h-panel-bar"><span class="h-panel-title">三方数据源配置</span></div>
            <div class="margin-top margin-left margin-right">
                <Button size="s" color="primary" @click="editDef(null)">新增</Button>
                <Button size="s" @click="exportAllDef">导出全部</Button>
                <Button size="s" @click="triggerDefImport">导入</Button>
                <input type="file" ref="defFile" accept=".json,application/json" style="display:none" @change="doDefImport">
            </div>
            <div class="h-panel-body">
                <table class="grid">
                    <thead>
                    <tr>
                        <th>名称</th>
                        <th style="width:120px">识别码</th>
                        <th style="width:60px">列</th>
                        <th style="width:90px">数据总数</th>
                        <th style="width:90px">凭证总数</th>
                        <th style="width:90px">状态</th>
                        <th style="width:160px">操作</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="d in definitions" :key="d.id">
                        <td>{{d.name}}</td>
                        <td>{{d.code}}</td>
                        <td>{{(d.dataFields || []).length}}</td>
                        <td align="right">{{d.dataCount}}</td>
                        <td align="right">{{d.voucherCount}}</td>
                        <td>{{d.enabled ? '已启用' : '已禁用'}}</td>
                        <td class="actions">
                            <span @click="editDef(d)">编辑</span>
                            <span @click="exportDef(d)">导出</span>
                            <span @click="removeDef(d)">删除</span>
                        </td>
                    </tr>
                    <tr v-if="!definitions.length">
                        <td colspan="7" class="text-center" style="padding:20px">暂无数据模型</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </Modal>

        <!-- 数据模型表单 -->
        <Modal v-model="defFormShow" type="drawer-right" hasCloseIcon :width="1000">
            <tripartite-definition-form ref="defForm" :entity="defEntity" @success="onDefSaved" @close="defFormShow = false"/>
        </Modal>

        <!-- 凭证模板 -->
        <Modal v-model="tplShow" type="drawer-right" hasCloseIcon :width="1200">
            <tripartite-voucher-tpl v-if="tplShow" :definition="current" @close="tplShow = false"/>
        </Modal>

        <!-- 新增/编辑业务数据 -->
        <Modal v-model="dataFormShow" type="drawer-right" hasCloseIcon :width="800">
            <tripartite-data-form v-if="dataFormShow" :definition="current" :entity="dataEntity"
                                  @success="onDataSaved" @close="dataFormShow = false"/>
        </Modal>

        <!-- 数据导入 -->
        <Modal v-model="importShow" :width="560">
            <div class="h-panel-bar"><span class="h-panel-title">{{(current.name || '') + '数据导入'}}</span></div>
            <div class="h-panel-body">
                <p>第一步：<a class="blue-color" href="javascript:;" @click="downloadTemplate">请点击下面的链接下载Excel模板</a>，并按照模板填写信息</p>
                <p class="margin-top">
                    第二步：导入Excel模板文件
                    <input type="file" ref="dataFile" accept=".xlsx,.xls" style="display:none" @change="onFilePicked">
                    <Button size="s" @click="$refs.dataFile.click()">选取文件</Button>
                    <span v-if="fileName" class="margin-left">已选：{{fileName}}</span>
                </p>
            </div>
            <div class="h-panel-bar text-right">
                <Button @click="importShow = false">取消</Button>
                <Button color="primary" :disabled="!file" :loading="importing" @click="doImport">导入</Button>
            </div>
        </Modal>

        <!-- 导入结果 -->
        <Modal v-model="importResultShow" :width="560">
            <div class="h-panel-bar"><span class="h-panel-title">导入结果</span></div>
            <div class="h-panel-body" v-if="importResult">
                <p>共读取 {{importResult.total}} 行，新增 {{importResult.addCount}} 条，
                    更新 {{importResult.updateCount}} 条，失败 {{importResult.failCount}} 条。</p>
                <table class="grid margin-top" v-if="importResult.failCount">
                    <thead>
                    <tr>
                        <th style="width:80px">行号</th>
                        <th>失败原因</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(f, i) in importResult.failures" :key="i">
                        <td align="center">第{{f.row}}行</td>
                        <td class="red-color">{{f.reason}}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="h-panel-bar text-right">
                <Button color="primary" @click="importResultShow = false">知道了</Button>
            </div>
        </Modal>

        <!-- 生成凭证预览 -->
        <Modal v-model="genShow" type="drawer-right" hasCloseIcon :width="1280">
            <tripartite-generate-voucher v-if="genShow" :definition="current" :records="checkedRows"
                                         @close="genShow = false" @success="onGenerated"/>
        </Modal>
    </app-content>
</template>

<script>
    import TripartiteDefinitionForm from './TripartiteDefinitionForm';
    import TripartiteVoucherTpl from './TripartiteVoucherTpl';
    import TripartiteDataForm from './TripartiteDataForm';
    import TripartiteGenerateVoucher from './TripartiteGenerateVoucher';

    const VOUCHERED_OPTIONS = [
        {title: '全部记录', key: 0},
        {title: '已生成凭证', key: 1},
        {title: '未生成凭证', key: 2}
    ];

    export default {
        name: "Tripartite",
        components: {TripartiteDefinitionForm, TripartiteVoucherTpl, TripartiteDataForm, TripartiteGenerateVoucher},
        data() {
            return {
                definitions: [],
                definitionId: null,
                datas: [],
                pagination: {page: 1, total: 0, size: 20},
                query: {dateRange: null, vouchered: 0, filters: {}},
                showFilter: false,
                voucheredOptions: VOUCHERED_OPTIONS,
                importExportMenu: ['数据导入', '导出列表数据', '导出选中数据', '导出全部数据'],
                defManagerShow: false,
                defFormShow: false,
                defEntity: null,
                tplShow: false,
                dataFormShow: false,
                dataEntity: null,
                importShow: false,
                fileName: '',
                file: null,
                importing: false,
                importResult: null,
                importResultShow: false,
                genShow: false
            };
        },
        computed: {
            current() {
                return this.definitions.find(d => d.id === this.definitionId) || {};
            },
            dataFields() {
                // 表格列：全部数据列（含期间字段），与商业版一致
                return (this.current.dataFields || []);
            },
            filterFields() {
                // 高级检索：排除期间字段（期间用顶部日期区间过滤）
                return (this.current.dataFields || []).filter(f => !f.period);
            },
            checkedRows() {
                return this.datas.filter(v => v._checked);
            },
            checkedIds() {
                return this.checkedRows.map(v => v.id);
            },
            checkAll() {
                return this.datas.length > 0 && this.datas.every(v => v._checked);
            }
        },
        watch: {
            'query.filters': {
                handler() {
                },
                deep: true
            }
        },
        methods: {
            loadDefinitions() {
                this.$api.tripartite.definition.list().then(({data}) => {
                    this.definitions = data || [];
                    if (!this.definitionId && this.definitions.length) {
                        this.definitionId = this.definitions[0].id;
                    }
                    // 数据列变化时重建检索条件，避免模板访问未初始化的过滤对象
                    this.resetFilters();
                    if (this.definitionId) {
                        this.loadList();
                    }
                });
            },
            selectDef(d) {
                this.definitionId = d.id;
                this.pagination.page = 1;
                this.showFilter = false;
                this.resetFilters();
                this.loadList();
            },
            resetFilters() {
                let f = {};
                this.dataFields.forEach(fd => {
                    if (fd.fieldType === 'NUMBER' || fd.fieldType === 'DATE') {
                        f[fd.fieldName] = {start: null, end: null};
                    } else {
                        f[fd.fieldName] = '';
                    }
                });
                this.query.filters = f;
            },
            loadList() {
                if (!this.definitionId) {
                    this.datas = [];
                    return;
                }
                let range = this.query.dateRange || [];
                let param = {
                    page: this.pagination.page,
                    pageSize: 20,
                    start: range[0] || '',
                    end: range[1] || '',
                    vouchered: this.query.vouchered,
                    filters: this.query.filters
                };
                this.$api.tripartite.data.page(this.definitionId, param).then(({data}) => {
                    this.datas = (data.records || []).map(v => Object.assign({}, v, {_checked: false}));
                    this.pagination = {page: data.current, total: data.total, size: data.size};
                });
            },
            currentChange() {
                this.loadList();
            },
            resetQuery() {
                this.query.dateRange = null;
                this.query.vouchered = 0;
                this.resetFilters();
                this.pagination.page = 1;
                this.loadList();
            },
            toggleAll() {
                let val = !this.checkAll;
                this.datas.forEach(v => {
                    if (!v.voucherId) {
                        v._checked = val;
                    }
                });
            },
            isFirstNumber(f) {
                let nums = this.dataFields.filter(x => x.fieldType === 'NUMBER');
                return nums.length && nums[0].fieldName === f.fieldName;
            },
            sumOf(f) {
                let total = 0;
                this.datas.forEach(d => {
                    let v = parseFloat((d.dataValue || {})[f.fieldName]);
                    if (!isNaN(v)) {
                        total += v;
                    }
                });
                return this.$options.filters.numFormat(total);
            },
            formatValue(v, f) {
                if (v === null || v === undefined) {
                    return '';
                }
                if (f.fieldType === 'NUMBER') {
                    return this.$options.filters.numFormat(v);
                }
                return v;
            },
            add() {
                if (!this.definitionId) {
                    this.$Message('请先选择数据模型');
                    return;
                }
                this.dataEntity = null;
                this.dataFormShow = true;
            },
            edit(item) {
                this.dataEntity = item;
                this.dataFormShow = true;
            },
            onDataSaved() {
                this.dataFormShow = false;
                this.loadList();
                this.loadDefinitions();
            },
            remove(item) {
                this.$Confirm('确认删除该记录吗？').then(() => {
                    this.$api.tripartite.data.delete(this.definitionId, item.id).then(({data}) => {
                        this.afterDelete(data);
                    });
                });
            },
            batchDelete() {
                if (!this.checkedIds.length) {
                    this.$Message('请选择需要删除的记录~');
                    return;
                }
                this.$Confirm(`确认删除选中的 ${this.checkedIds.length} 条记录吗？`).then(() => {
                    this.$api.tripartite.data.batchDelete(this.definitionId, this.checkedIds).then(({data}) => {
                        this.afterDelete(data);
                    });
                });
            },
            afterDelete(res) {
                if (res && res.failedList && res.failedList.length) {
                    let reasons = {};
                    res.failedList.forEach(f => {
                        reasons[f.reason] = (reasons[f.reason] || 0) + 1;
                    });
                    let msg = Object.keys(reasons).map(k => `${k} ${reasons[k]} 条`).join('，');
                    this.$Message(`成功删除 ${res.successCount} 条，${res.failedList.length} 条删除失败（${msg}）`);
                } else {
                    this.$Message(`成功删除 ${(res && res.successCount) || 0} 条记录`);
                }
                this.loadList();
                this.loadDefinitions();
            },
            onImportExport(key) {
                if (!this.definitionId) {
                    this.$Message('请先选择数据模型');
                    return;
                }
                if (key === '数据导入') {
                    this.fileName = '';
                    this.file = null;
                    this.importShow = true;
                    return;
                }
                let range = this.query.dateRange || [];
                let filters = encodeURIComponent(JSON.stringify(this.query.filters || {}));
                let base = `/api/tripartite/data/${this.definitionId}/download?start=${range[0] || ''}&end=${range[1] || ''}&vouchered=${this.query.vouchered}&filters=${filters}`;
                if (key === '导出全部数据') {
                    window.open(base + '&all=true');
                } else if (key === '导出选中数据') {
                    if (!this.checkedIds.length) {
                        this.$Message('请先选择需要导出的记录~');
                        return;
                    }
                    window.open(`/api/tripartite/data/${this.definitionId}/download?ids=${this.checkedIds.join(',')}`);
                } else {
                    window.open(base);
                }
            },
            downloadTemplate() {
                window.open(`/api/tripartite/data/${this.definitionId}/template`);
            },
            onFilePicked(e) {
                this.file = e.target.files[0] || null;
                this.fileName = this.file ? this.file.name : '';
            },
            doImport() {
                if (!this.file) {
                    return;
                }
                let fd = new FormData();
                fd.append('file', this.file);
                this.importing = true;
                this.$api.tripartite.data.importData(this.definitionId, fd).then(({data}) => {
                    this.importShow = false;
                    this.loadList();
                    this.loadDefinitions();
                    let d = data || {};
                    this.importResult = d;
                    if (d.failCount) {
                        this.importResultShow = true;
                    } else {
                        this.$Message(`导入完成：新增 ${d.addCount || 0} 条，更新 ${d.updateCount || 0} 条`);
                    }
                }).finally(() => {
                    this.importing = false;
                });
            },
            openTpl() {
                if (!this.definitionId) {
                    this.$Message('请先选择数据模型');
                    return;
                }
                this.tplShow = true;
            },
            openGenerate() {
                let rows = this.checkedRows.filter(v => !v.voucherId);
                if (!rows.length) {
                    this.$Message('没有选择需要生成凭证的记录~');
                    return;
                }
                this.genShow = true;
            },
            onGenerated() {
                this.genShow = false;
                this.loadList();
                this.loadDefinitions();
            },
            openDefinitionManager() {
                this.defManagerShow = true;
            },
            editDef(d) {
                this.defEntity = d ? Object.assign({}, d) : null;
                this.defFormShow = true;
            },
            onDefSaved() {
                this.defFormShow = false;
                this.loadDefinitions();
            },
            removeDef(d) {
                this.$Confirm(`数据模型 ${d.name} 将被删除，是否继续？`).then(() => {
                    this.$api.tripartite.definition.delete(d.id).then(() => {
                        this.$Message('删除成功');
                        if (this.definitionId === d.id) {
                            this.definitionId = null;
                            this.datas = [];
                        }
                        this.loadDefinitions();
                    });
                });
            },
            exportDef(d) {
                this.$api.tripartite.definition.exportConfig(d.id).then(({data}) => {
                    this.downloadJson(data.filename, data.data);
                });
            },
            exportAllDef() {
                this.$api.tripartite.definition.exportAll().then(({data}) => {
                    this.downloadJson(data.filename, data.data);
                });
            },
            triggerDefImport() {
                this.$refs.defFile.click();
            },
            doDefImport(e) {
                let file = e.target.files[0];
                if (!file) {
                    return;
                }
                let fd = new FormData();
                fd.append('file', file);
                this.$api.tripartite.definition.importConfig(fd).then(({data}) => {
                    let warnings = (data && data.warnings) || [];
                    if (warnings.length) {
                        this.$Message('部分配置在当前账套未匹配，已自动置空，请手工处理：' + warnings.join(' '));
                    } else {
                        this.$Message('导入成功');
                    }
                    this.loadDefinitions();
                });
                e.target.value = '';
            },
            downloadJson(filename, obj) {
                let blob = new Blob([JSON.stringify(obj, null, 2)], {type: 'application/json;charset=utf-8;'});
                let url = URL.createObjectURL(blob);
                let a = document.createElement('a');
                a.href = url;
                a.download = filename || '三方数据源配置.json';
                a.click();
                URL.revokeObjectURL(url);
            }
        },
        mounted() {
            this.loadDefinitions();
        }
    };
</script>

<style lang="less" scoped>
    .tp-wrap {
        display: flex;
        gap: 16px;
        padding: 14px;
        height: calc(100vh - 110px);
    }

    .tp-side {
        width: 280px;
        flex: none;
        border: 1px solid @gray2-color;
        display: flex;
        flex-direction: column;

        .tp-side-head {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 10px 12px;
            border-bottom: 1px solid @gray2-color;
            font-weight: bold;
        }

        .tp-side-body {
            flex: 1;
            overflow: auto;
        }

        .tp-side-item {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 8px 12px;
            cursor: pointer;

            &.selected, &:hover {
                background-color: @hover-background-color;
                color: @primary-color;
            }
        }

        .tp-badge {
            background: @gray2-color;
            border-radius: 8px;
            padding: 0 6px;
            font-size: 12px;
        }
    }

    .tp-main {
        flex: 1;
        width: 0;
        border: 1px solid @gray2-color;
        display: flex;
        flex-direction: column;
        padding: 10px 12px;
        overflow: auto;
    }

    .tp-title {
        font-size: 15px;
        font-weight: bold;
        margin-bottom: 8px;
    }

    .tp-desc {
        font-size: 12px;
        font-weight: normal;
        color: @dark2-color;
        margin-left: 8px;
    }

    .tp-cfg {
        color: @primary-color;
        cursor: pointer;
        font-size: 13px;
        font-weight: normal;
    }

    .tp-toolbar {
        margin-bottom: 8px;
        overflow: hidden;
    }

    .tp-filter {
        border: 1px solid @gray2-color;
        padding: 10px;
        margin-bottom: 10px;
        display: flex;
        flex-wrap: wrap;
        gap: 12px;

        .tp-filter-item {
            label {
                display: inline-block;
                width: 90px;
                text-align: right;
                margin-right: 6px;
                color: @dark1-color;
            }
        }
    }

    .actions span {
        color: @primary-color;
        cursor: pointer;
        margin-right: 8px;
    }

    tfoot td {
        font-weight: bold;
        background: @gray4-color;
    }
</style>
